import type { AvailableTransition } from "./benefit-types"

/** Prefer forward progress, never a destructive action or a re-entry into the current state. */
export function primaryLifecycleAction(currentState: string, actions: AvailableTransition[]): AvailableTransition | undefined {
  const next: Record<string, string> = {
    Pending: "Complete", Draft: "Complete", Completed: "SubmitForReview", InReview: "Proof",
    Proofed: "Certify", Certified: "Submit", LegacyCertified: "Submit", PreSeasonNoStart: "BeginIntake",
  }
  return actions.find(a => a.trigger === next[currentState]) ?? actions.find(a => !a.isDestructive) ?? actions[0]
}
